import { httpClient, apiLinks } from '@app/utils';
import { Department } from '@admin/manage-customer/models/user';
import { DepartmentResponse } from '@app/models/department';
import {
  CreateModel,
  DeleteModel,
  DepartmentModel,
  DepartmentNode,
  ModifyDepartment,
  UpdateModel,
} from '../models/department';

const getAllDepartments = async (
  code?: string,
  name?: string,
): Promise<DepartmentNode[]> => {
  const result = await httpClient.get({
    url: apiLinks.admin.departmentManagement.getAll,
    params: {
      departmentCode: code,
      departmentName: name,
    },
  });
  return result.data as DepartmentNode[];
};

const getAllDepartmentsForAdmin = async (
  code?: string,
  name?: string,
): Promise<DepartmentNode[]> => {
  const result = await httpClient.get({
    url: apiLinks.admin.departmentManagement.getAllForAdmin,
    params: {
      departmentCode: code,
      departmentName: name,
    },
  });
  return result.data as DepartmentNode[];
};

const getDepartment = async (
  index: number,
  size: number,
  code?: string,
  name?: string,
): Promise<DepartmentResponse> => {
  const result = await httpClient.get({
    url: apiLinks.admin.departmentManagement.getSearch,
    params: {
      index,
      size,
      departmentCode: code,
      departmentName: name,
    },
  });
  return result.data as DepartmentResponse;
};

const getDepartmentDetail = async (id: number): Promise<DepartmentNode> => {
  const result = await httpClient.get({
    // url: apiLinks.admin.departmentManagement.department.getdetail + '?id=' + id,
    url: apiLinks.admin.departmentManagement.department.getdetail,
    params: { id },
  });
  return result.data as DepartmentNode;
};

const createDepartment = async (model: ModifyDepartment): Promise<void> => {
  await httpClient.post<void>({
    url: apiLinks.admin.departmentManagement.department.create,
    data: model,
  });
};

const updateDepartment = async (model: ModifyDepartment): Promise<void> => {
  await httpClient.put<void>({
    url: apiLinks.admin.departmentManagement.department.update,
    data: model,
  });
};

const deleteDepartment = async (
  model: DeleteModel,
): Promise<DepartmentNode> => {
  const result = await httpClient.put({
    url: apiLinks.admin.departmentManagement.department.update,
    data: model,
  });
  console.log(result.data);
  return result.data as DepartmentNode;
};

export const departmentServices = {
  getAllDepartments,
  getDepartment,
  getDepartmentDetail,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  getAllDepartmentsForAdmin,
};
